import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { uxReducerPath } from './const';
import { UXSliceShape, UXState } from './types';

const UX_STATE = {
  loginShown: 0b01,
  headerFindBtnTooltipShown: 0b10,
  needHelpShownForGuest: 0b100,
  needHelpShownForRegisteredUser: 0b1000,
};

export * from './const';
export * from './types';

const initialState: UXState = {
  flags: 0,
  notificationsSubscribeReminderLastShownInMs: undefined,
};

export const UXSlice = createSlice({
  name: `@@app/${uxReducerPath}`,
  initialState,
  reducers: {
    setloginShown(state, action: PayloadAction<boolean>) {
      if (action.payload) {
        state.flags |= UX_STATE.loginShown;
      } else {
        state.flags &= ~UX_STATE.loginShown;
      }
    },
    setTooltipShown(state, action: PayloadAction<boolean>) {
      action.payload ? (state.flags |= UX_STATE.headerFindBtnTooltipShown) : (state.flags &= ~UX_STATE.headerFindBtnTooltipShown);
    },
    setNeedHelpShownForGuest(state, action: PayloadAction<boolean>) {
      action.payload ? (state.flags |= UX_STATE.needHelpShownForGuest) : (state.flags &= ~UX_STATE.needHelpShownForGuest);
    },
    setNeedHelpShownForRegisteredUser(state, action: PayloadAction<boolean>) {
      action.payload ? (state.flags |= UX_STATE.needHelpShownForRegisteredUser) : (state.flags &= ~UX_STATE.needHelpShownForRegisteredUser);
    },
    setNotificationsSubscribeReminderLastShownInMs(state) {
      state.notificationsSubscribeReminderLastShownInMs = Date.now();
    },
  },
});

export const loginShownSelector = (state: UXSliceShape) => (state[uxReducerPath].flags & UX_STATE.loginShown) !== 0;

export const headerFindBtnTooltipShownSelector = (state: UXSliceShape) =>
  (state[uxReducerPath].flags & UX_STATE.headerFindBtnTooltipShown) !== 0;

export const needHelpShownForGuestSelector = (state: UXSliceShape) => (state[uxReducerPath].flags & UX_STATE.needHelpShownForGuest) !== 0;

export const needHelpShownForRegisteredUserSelector = (state: UXSliceShape) =>
  (state[uxReducerPath].flags & UX_STATE.needHelpShownForRegisteredUser) !== 0;

export const notificationsSubscribeReminderLastShownInMsSelector = (state: UXSliceShape) =>
  state[uxReducerPath].notificationsSubscribeReminderLastShownInMs;
